import { _initialState } from './_initialState';
import { addDropZones } from './actions';

export const dropZoneStore = (set, get) => ({
  ..._initialState,
  addDropZones: (zones,
  ) => addDropZones(
    set,
    get,
    zones
  ),
  resetDropZones: () => set(
    { dropZones: _initialState.dropZones },
    false,
    { type: 'RESET' }
  ),
});
